<template>
  <div>
    <div class="fileUploadCard"
        :class="{ over: isDragOver }"
        @dragover.prevent="onDrag('over')"
        @dragleave="onDrag('leave')"
        @drop.stop="onDrop"
        v-if="addableFileCount !== 0">
      <input type="file" @change="onChange" multiple="multiple" accept="image/jpeg,image/png,image/jpg,image/gif" ref="file"/>
      <p class="text1 pc">ここにファイルをドロップ</p>
      <p class="text2 pc">または</p>
      <div class="button outlined">
        <span class="pc" for="image">ファイルを選択</span>
        <span class="sp icon" for="image">写真を追加</span>
      </div>
    </div>
    <div class="formError" v-if="imageSizeOver">1MB以上の画像はアップロードできません。</div>
    <div class="image-preview">
      <div v-for="(file, i) in displayFiles" :key="i" class="preview-box">
        <span class="removal" @click="remove(i, 'file')"></span>
        <img :src="file.src">
      </div>
      <div v-for="(image, i) in images" :key="i" class="preview-box">
        <span class="removal" @click="remove(i, 'image')"></span>
        <img :src="image.src">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fileLimit: {
      type: Number,
      default: 5
    },
    photos: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      images: [], // 既存画像
      files: [], // 画像データ
      displayFiles: [], // 画像表示用
      addableFileCount: 5,
      isDragOver: false,
      formData: new FormData(),
      imageSizeOver: false
    };
  },
  mounted() {
    this.setUploadedFiles();
  },
  methods: {
    onDrag(type) {
      this.isDragOver = type === "over";
    },
    onDrop(event) {
      this.isDragOver = false;
    },
    onChange(event) {
      const files = event.target.files;
      this.addImage(files);
    },
    addImage(files) {
      const addCount = (this.addableFileCount < files.length) ? this.addableFileCount : files.length;
      this.imageSizeOver = false;
      if (addCount > 0) {
        let addFiles = [];
        for (let i = 0; i < addCount; i++) {
          if (files[i].size > 1024 * 1024) {
            this.imageSizeOver = true;
            continue;
          }
          addFiles.unshift(files[i]);
        }
        // 既存のデータにマージ
        this.files = addFiles.concat(this.files);
        // 追加分だけ読み込む
        for (const i in addFiles) {
          this.readImage(addFiles[i]);
        }
      }
      // ファイル追加可能枚数更新
      this.addableFileCount = this.fileLimit - (this.files.length + this.images.length);
      // フォーム内データのリセット
      this.$refs.file.value = null;
    },
    readImage(file) {
      let reader = new FileReader();
      reader.onload = this.loadImage;
      reader.readAsDataURL(file);
    },
    loadImage(e) {
      let image = new Image();
      image.src = e.target.result;
      this.displayFiles.push({
        src: e.target.result
      });
    },
    remove(i, type) {
      if (type === 'image') {
        this.images.splice(i, 1);
      } else if(type === 'file') {
        this.files.splice(i, 1);
        this.displayFiles.splice(i, 1);
      }

      // ファイル追加可能枚数更新
      this.addableFileCount = this.fileLimit - (this.files.length + this.images.length);
    },
    async setUploadedFiles() {
      if (this.photos.length > 0) {
        this.images = this.photos;
        this.addableFileCount = this.fileLimit - this.photos.length;
      } else {
        this.addableFileCount = this.fileLimit;
      }
    }
  },
  watch: {
    images(newValue, oldValue) {
      this.$emit('input', {
        images: newValue,
        files: this.files
      })
    },
    files(newValue, oldValue) {
      this.$emit('input', {
        images: this.images,
        files: newValue
      })
    }
  }
};
</script>

<style lang="scss">
.fileUploadCard {
  position: relative;
  input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
  +.formError {
    font-size: 1.2rem !important;
    color: #c63200 !important;
    line-height: 1 !important;
    margin: 1.6rem !important;
    text-align: center;
  }
}
.image-preview {
  display: flex;
  margin-top: 10px;
  overflow-x: scroll;
  .preview-box {
    width: 45%;
    flex-shrink: 0;
    position: relative;
    margin: 5px;
    border-radius: 30px;
    &:before{
      content: "";
      display: block;
      padding-top: 100%;
    }
    img {
      border-radius: 15px;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      object-fit: cover;
    }
    .removal {
      background: url(/assets/img/common/close_black.svg) center center/contain no-repeat;
      z-index: 1;
      position: absolute;
      width: 10px;
      height: 10px;
      top: 10px;
      left: 10px;
      cursor: pointer;
    }
  }
}
</style>
